module.exports = __webpack_public_path__ + "img/bank-09-kakao.b693ba95.svg";